import { useTranslation } from 'react-i18next';
import { Row, Form, Input, Select } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useGetCountriesNew } from 'all-in-one-shared-api';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import React, { useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { corrAddressListItem } from '../ChangeContactInformation';
// import { Converter } from 'opencc-js';
// import styled from 'styled-components';
export const ChangeCorrespondCard = (props: { corrAddressList: corrAddressListItem[] }) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  const { token } = useKeycloakReady();
  // const [residentialAddressCountry, setresidentialAddress5] = useState('');
  // const [ContactInformation, setContactInformation] = useState('');
  const { shouldFetch: shouldFecthGetCountry, data: countriesDataList } = useGetCountriesNew(
    'useGetCountriesNew',
    token || '',
    '',
    '2',
  );
  const myCountryList = countriesDataList?.residentialCountries.map((item) => {
    return {
      label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
      value: item.t3645Alpha3Country,
      sanctionLevel: item.sanctionLevel,
    };
  });
  const myCountryList2 = countriesDataList?.residentialCountries.map((item) => {
    return {
      label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
      value: item.t3645Alpha3Country,
      sanctionLevel: item.sanctionLevel,
      code: item.t3645Alpha3Country,
      descEn: item.countryName,
      descTc: item.countryNameTc,
    };
  });
  // const corresCountryList = countriesDataList?.correspondenceCountries.map((item) => {
  //   return {
  //     label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
  //     value: item.t3645Alpha3Country,
  //     sanctionLevel: item.sanctionLevel,
  //   };
  // });
  const [maxlenth1, setmaxlenth1] = useState<number>();
  const [maxlenth2, setmaxlenth2] = useState<number>();
  const [maxlenth3, setmaxlenth3] = useState<number>();
  const [maxlenth4, setmaxlenth4] = useState<number>();
  useEffect(() => {
    shouldFecthGetCountry(true);
  }, [shouldFecthGetCountry]);
  // useEffect(() => {
  //   const a = myCountryList?.find((item) => item.value === form.getFieldValue('residentialAddress5'))?.label;
  //   if (a) {
  //     setresidentialAddress5(a);
  //   }
  //   // eslint-disable-line react-hooks/exhaustive-deps
  // }, [setresidentialAddress5, myCountryList, form]);
  // const {
  //   shouldFetch: shouldFecthDrop,
  //   data: dropData,
  //   // isLoading: dropDataisLoading,
  // } = usePolicyDropDown('usePolicyDropDown', token || '');
  // const policyTypesObject: { label: string; label2: string; value: string }[] = [];
  // useEffect(() => {
  //   shouldFecthDrop(true);
  // }, [shouldFecthDrop]);
  const dropDatanew = props.corrAddressList?.filter((item) =>
    form.getFieldValue('correspondencePolicyNo')?.includes(item.policyNumber),
  );

  // dropDatanew?.map((item) => {
  //   policyTypesObject.push({
  //     label: i18n.language == 'en' ? item.productName : item.productNameTC,
  //     label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
  //     value: item.policyNumber,
  //   });
  // });
  // const [highRiskFlag, setHighRiskFlag] = useState(false);
  const changeCountry = (value: string) => {
    //如果這個value對應的國家的sanctionLevel為高風險，那麼返回true
    // setHighRiskFlag(
    //   myCountryList2?.find((item) => item.code === value)?.sanctionLevel.toLowerCase() == 'HIGH'.toLowerCase(),
    // );
    form.setFieldsValue({
      highRiskFlag:
        myCountryList2?.find((item) => item.code === value)?.sanctionLevel.toLowerCase() == 'HIGH'.toLowerCase(),
    });
  };
  // const isTraditionalChinese = async (text: string) => {
  //   // 如果轉換後的文本與原文本不同，則可能是繁體
  //   const converter = Converter({ from: 'cn', to: 'hk' });
  //   return (await converter(text)) !== text;
  // };
  const ResidentialAddresschange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/[\u4e00-\u9fa5]/.test(e.target.value)) {
      setmaxlenth1(14);
    } else {
      setmaxlenth1(30);
    }
  };
  const ResidentialAddresschange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/[\u4e00-\u9fa5]/.test(e.target.value)) {
      setmaxlenth2(14);
    } else {
      setmaxlenth2(30);
    }
  };
  const ResidentialAddresschange3 = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/[\u4e00-\u9fa5]/.test(e.target.value)) {
      setmaxlenth3(14);
    } else {
      setmaxlenth3(30);
    }
  };
  const ResidentialAddresschange4 = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/[\u4e00-\u9fa5]/.test(e.target.value)) {
      setmaxlenth4(14);
    } else {
      setmaxlenth4(30);
    }
  };
  const verifyFun = /^[Ａ-Ｚａ-ｚ０-９A-Za-z0-9\u4e00-\u9fa5/／,，'‘’＇&＆ \u3000()（）.·．－-]+$/;
  return (
    <Row
      justify="center"
      gutter={[16, { xs: 8, sm: 8, lg: 16 }]}
      style={{ display: 'grid', justifyContent: 'flex-start' }}
      className="crossCheckbox"
    >
      <div style={{ display: 'grid' }}>
        {dropDatanew.map((item, index) => (
          <div key={index + 'dropData'} style={{ borderBottom: '1px solid #cccccc' }}>
            <div
              style={{
                color: '#6f7072',
                fontWeight: 'normal',
                fontSize: '17px',
                fontFamily: 'Roboto500',
                marginTop: index == 0 ? '0px' : '8px',
              }}
            >
              {i18n.language == 'en' ? item.productName : item.productNameTc}
            </div>
            <div
              style={{
                color: '#6f7072',
                fontWeight: 'normal',
                fontSize: '17px',
                fontFamily: 'Roboto500',
                marginBottom: '5px',
              }}
            >
              {`${t('life.enquiry.policyNo')}${item.policyNumber}`}
            </div>
          </div>
        ))}
      </div>
      <div>
        <div
          style={{
            fontSize: '17px',
            fontFamily: 'Roboto500',
            color: '#6F7072',
          }}
        >
          {t('life.MakeRequest.contact.maxResidentialAddress2')}
        </div>
        {/* <div
          style={{
            fontSize: '17px',
            fontFamily: 'Roboto500',
            color: '#6F7072',
          }}
        >
          {t('life.MakeRequest.contact.maxResidentialAddress')}
        </div> */}
      </div>
      <div className="crossform">
        <Form.Item
          preserve={true}
          rules={[
            { required: true, message: t('common.error.requiredField') },
            {
              validator: async (_, value) => {
                if (!value) return Promise.resolve();
                const isValidChars = verifyFun.test(value);
                if (!isValidChars) {
                  return Promise.reject(new Error(t('life.MakeRequest.contact.tcError'))); // 替换为你的翻译键
                }
                // if (await isTraditionalChinese(value)) {
                //   // 返回 Promise.reject 会触发表单错误
                //   return Promise.reject(new Error(t('life.MakeRequest.contact.tcError')));
                // }
                return Promise.resolve(); // 验证通过
              },
            },
          ]}
          name="corrAddress1"
        >
          <Input
            size="middle"
            placeholder={t('life.MakeRequest.contact.corrLine1')}
            maxLength={maxlenth1}
            onChange={ResidentialAddresschange}
            style={{
              // color: "white",
              // backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 10px',
            }}
          />
        </Form.Item>
        <Form.Item
          preserve={true}
          name="corrAddress2"
          rules={[
            { required: true, message: t('common.error.requiredField') },
            {
              validator: async (_, value) => {
                if (!value) return Promise.resolve();
                const isValidChars = verifyFun.test(value);
                if (!isValidChars) {
                  return Promise.reject(new Error(t('life.MakeRequest.contact.tcError'))); // 替换为你的翻译键
                }
                // if (await isTraditionalChinese(value)) {
                //   // 返回 Promise.reject 会触发表单错误
                //   return Promise.reject(new Error(t('life.MakeRequest.contact.tcError')));
                // }
                return Promise.resolve(); // 验证通过
              },
            },
          ]}
        >
          <Input
            size="middle"
            placeholder={t('life.MakeRequest.contact.corrLine2')}
            maxLength={maxlenth2}
            onChange={ResidentialAddresschange2}
            style={{
              // color: "white",
              // backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 10px',
            }}
          />
        </Form.Item>
        <Form.Item
          preserve={true}
          name="corrAddress3"
          rules={[
            {
              validator: async (_, value) => {
                if (!value) return Promise.resolve();
                const isValidChars = verifyFun.test(value);
                if (!isValidChars) {
                  return Promise.reject(new Error(t('life.MakeRequest.contact.tcError'))); // 替换为你的翻译键
                }
                // if (await isTraditionalChinese(value)) {
                //   // 返回 Promise.reject 会触发表单错误
                //   return Promise.reject(new Error(t('life.MakeRequest.contact.tcError')));
                // }
                // 验证通过
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            size="middle"
            placeholder={t('life.MakeRequest.contact.corrLine3')}
            maxLength={maxlenth3}
            onChange={ResidentialAddresschange3}
            style={{
              // color: "white",
              // backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 10px',
            }}
          />
        </Form.Item>
        <Form.Item
          preserve={true}
          name="corrAddress4"
          rules={[
            {
              validator: async (_, value) => {
                if (!value) return Promise.resolve();
                const isValidChars = verifyFun.test(value);
                if (!isValidChars) {
                  return Promise.reject(new Error(t('life.MakeRequest.contact.tcError'))); // 替换为你的翻译键
                }
                // if (await isTraditionalChinese(value)) {
                //   // 返回 Promise.reject 会触发表单错误
                //   return Promise.reject(new Error(t('life.MakeRequest.contact.tcError')));
                // }
                return Promise.resolve(); // 验证通过
              },
            },
          ]}
        >
          <Input
            size="middle"
            placeholder={t('life.MakeRequest.contact.corrLine4')}
            maxLength={maxlenth4}
            onChange={ResidentialAddresschange4}
            style={{
              // color: "white",
              // backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 10px',
            }}
          />
        </Form.Item>
        <Form.Item
          name="corrAddress5"
          preserve={true}
          rules={[{ required: true, message: t('common.error.requiredField') }]}
        >
          <Select
            showSearch
            className="crossaddres55"
            onChange={changeCountry}
            popupClassName="slectop2"
            placeholder={t('life.MakeRequest.contact.corrLine5')}
            filterOption={(input, myCountryList) =>
              (myCountryList?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
            options={myCountryList}
          ></Select>
        </Form.Item>
        {/* {highRiskFlag && (
          <div>
            <span
              style={{
                fontSize: '17px',
                fontFamily: 'Roboto400',
                color: '#6F7072',
              }}
            >
              {t('life.MakeRequest.contact.uploadaddress')}
            </span>
          </div>
        )} */}
      </div>
    </Row>
  );
};
